import { DiReact } from 'react-icons/di'
import { BiServer } from 'react-icons/bi'



const data = [
    { id: 1, icon: <DiReact />, title: 'Frontend Development', desc: 'Your projcet will look good, it will be responsive and accessible on all devices. Additionally, I will make sure your website as all it takes for the user to have fun.' },
    { id: 2, icon: <BiServer />, title: 'Backend Development', desc: "The secuity of your website is priority.It's taken serious right from the start of the project and this is to ensure your database is protected and your website is secure from attacks." }
]



export default data